import {
  CLIENT_LIST,
  CLIENT_CREATE,
  CLIENT_FILTER,
  CLIENT_UPDATE,
  CLIENT_CREATE_SUCCESS,
  CLIENT_UPDATE_SUCCESS,
  CLIENT_LIST_SUCCESS,
  CLIENT_REQUEST_FAILED,
} from "store/clients/actionTypes";

export const clientList = () => {
  return {
    type: CLIENT_LIST,
    payload: {},
  };
};

export const clientCreate = (client) => {
  return {
    type: CLIENT_CREATE,
    payload: client,
  };
};

export const clientFilter = (changeUrl) => {
  return {
    type: CLIENT_FILTER,
    payload: { changeUrl },
  };
};

export const clientUpdate = (id, data) => {
  return {
    type: CLIENT_UPDATE,
    payload: { id, data },
  };
};

export const clientListSuccess = (clients) => {
  return {
    type: CLIENT_LIST_SUCCESS,
    payload: clients,
  };
};

export const clientCreateSuccess = (clientCreated) => {
  return {
    type: CLIENT_CREATE_SUCCESS,
    payload: clientCreated,
  };
};

export const clientUpdateSuccess = (client) => {
  return {
    type: CLIENT_UPDATE_SUCCESS,
    payload: client,
  };
};

export const clientRequestFailed = (error) => {
  return {
    type: CLIENT_REQUEST_FAILED,
    payload: error,
  };
};
